import React from 'react';
import {connect} from 'react-redux';

import {AppState} from '../Store';
import {Article} from '../Services/ArticleService';
import {Author} from '../Services/AuthorService';
import {Survey} from '../Services/SurveyService';

import ArticlePreview from './ArticlePreview';
import SurveyWidget from './SurveyWidget';
import RatingWidget from './RatingWidget';
import AuthorWidget from './AuthorWidget';
import WeatherWidget from './WeatherWidget';

interface SidebarProps {
  articles: Article[];
  article?: Article;
  survey?: Survey;
  author?: Author;
}

function Sidebar({
  articles,
  article,
  survey,
  author,
}: SidebarProps) {
  return (
    <div className="col-12 col-md-8 col-lg-4">
      <AuthorWidget author={author} />
      <RatingWidget article={article} />
      <WeatherWidget />
      <SurveyWidget survey={survey} />
      <div className="sidebar-widget-area">
        <h5 className="title">Latest Articles</h5>
        <div className="widget-content">
          {articles.map(art => {
            return <ArticlePreview key={art.id} article={art} vertical={true} />;
          })}
        </div>
      </div>
    </div>
  );
}

const mapPropsToState = (state: AppState) => ({
  articles: state.home.recentArticles.items,
  article: state.articles.article,
  survey: state.home.survey,
  author: state.articles.article === undefined ? undefined : state.articles.article.author,
});

export default connect(mapPropsToState)(Sidebar);
